/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * FHIR gender identity codes, matching GenderIdentity in curai_fhir_tools. Distinct
 * from SexAtBirth: this is how the user identifies, not their sex assigned at birth.
 */
export type GenderIdentity =
  (typeof GenderIdentity)[keyof typeof GenderIdentity];

export const GenderIdentity = {
  male: "male",
  female: "female",
  "transgender-male": "transgender-male",
  "transgender-female": "transgender-female",
  "non-binary": "non-binary",
  other: "other",
  "non-disclose": "non-disclose",
} as const;
